import { render } from "./DiscussionQuestItem.vue?vue&type=template&id=76bcadfa&scoped=true"
import script from "./DiscussionQuestItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionQuestItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionQuestItem.vue?vue&type=style&index=0&id=76bcadfa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bcadfa"]])

export default __exports__